import {
	ReactElement,
	useMemo,
} from "react";
import { millisecondsInAMinute } from "client/DateAndTime/dateTimeUtils";
import { TimeOnly } from "client/DateAndTime/timeOnly";
import { BaseTimePicker, BaseTimePickerProps } from "./BaseTimePicker";
import { isAndroid, isIos } from "client_legacy/ndaw/mobile";

type TimeOnlyPickerProps = Omit<
	BaseTimePickerProps,
	"timeListOptions"
	| "shouldRenderNative"
>;

export const TimeOnlyPicker = (props: TimeOnlyPickerProps): ReactElement => {
	const timeListOptions = useMemo(
		(): readonly TimeOnly[] => {
			const millisecondsInDay: number = 24 * 60 * millisecondsInAMinute;
			const items: TimeOnly[] = [];

			for (let i = 0; i < millisecondsInDay; i += 30 * millisecondsInAMinute) {
				const totalMinutes: number = i / millisecondsInAMinute;
				const hour: number = Math.floor(totalMinutes / 60);
				const minute: number = totalMinutes % 60;
				items.push(new TimeOnly(hour, minute, 0, 0));
			}

			return items;
		},
		[]
	);

	const shouldRenderNative: boolean = useMemo(
		(): boolean => {
			const isMobileDevice: boolean = isAndroid() || isIos();

			return isMobileDevice;
		},
		[]
	);

	return (
		<BaseTimePicker
			{...props}
			shouldRenderNative={shouldRenderNative}
			timeListOptions={timeListOptions}
			dropDownWidth="fill"
		/>
	);
};
TimeOnlyPicker.displayName = "TimeOnlyPicker";